import React, { Component } from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { USER_ROLE } from 'constants';
import { getUserRole } from 'utils';
import { getNumEnding } from '../utils';
import { hideNotification } from 'actions/payments';
import PayForTarifBtn from '../PayForTarifBtn';
import iconAlert from 'assets/images/icons/alert.svg';
import s from '../SubscriptionBar/style.scss';
import is from './style.scss';
import withObservePayments from 'decorators/withObservePayments';
import { TARIFFS } from 'constants';
import { withTranslation } from 'react-i18next';

const mapStateToProps = ({ profile, payments }) => ({
  profile,
  isShown: payments.isNotificationShown
});

@withObservePayments
@connect(mapStateToProps, { hideNotification })
class Notification extends Component {
  close = () => {
    this.props.hideNotification();
  }

  getTarif = (pricing) => {
    const { t } = this.props;
    switch (pricing) {
      case TARIFFS.COMPANY:
        return t('components.payments.notification.company');
      case TARIFFS.PERSONAL:
        return t('components.payments.notification.personal');
      case TARIFFS.COMPANY_TEST:
        return t('components.payments.notification.company_test');
      case TARIFFS.PERSONAL_TEST:
        return t('components.payments.notification.personal_test');
      default:
        console.warn('No such tarif name: ', name);
        return t('components.payments.notification.default');
    }
  }

  render() {
    const { className, profile, isShown, t } = this.props;
    if (!isShown) return null;
    const { tariff, agencyName } = profile;
    const role = getUserRole(profile);
    const tarif = this.getTarif(tariff.pricing);
    const classes = cx(s.root, className, is.root);
    const isIndividual = role === USER_ROLE.INDIVIDUAL;
    const countDay = tariff.countDay;
    return (
      <div className={classes}>
        <div className={cx(s.TarifTerm, is.text)}>
          <img src={iconAlert} alt="" className={s.IconAlert} />
          <span>
            {t('components.payments.notification.title', {
              days: `${countDay} ${getNumEnding(countDay, [t('components.payments.notification.day1'), t('components.payments.notification.day2'), t('components.payments.notification.day3')])}`,
              tarif,
              agencyName: isIndividual ? '' : `«${agencyName}»`
            })}
          </span>
        </div>
        {isIndividual &&
          <PayForTarifBtn
            className={s.PayForTarifBtn}
            onClick={this.close}
          />
          // :
          // <ShowTarifBtn />
        }
        <img onClick={this.close} className={is.close} src="/static/media/cross.87a14b4c.svg" alt="" />
      </div>
    );
  }
}

export default withTranslation()(Notification);



// WEBPACK FOOTER //
// ./src/components/Payments/Notification/Notification.js